export enum LoanInstalmentComponentTypes {
  PrincipalDue = "PRINCIPAL_DUE",
  PrincipalPaid = "PRINCIPAL_PAID",
  InterestDue = "INTEREST_DUE",
  InterestPaid = "INTEREST_PAID",
  FailureFeeDue = "FAILURE_FEE_DUE",
  FailureFeePaid = "FAILURE_FEE_PAID",
  TotalAmountDue = "TOTAL_AMOUNT_DUE",
  TotalAmountPaid = "TOTAL_AMOUNT_PAID",
}
